import { defineMessages } from 'react-intl'

const messages = {
  unpack: {
    id: 'app.components.product-modal.unpack',
    defaultMessage: 'Unpack',
  },
  printLabel: {
    id: 'app.components.product-modal.print-label',
    defaultMessage: 'Print',
  },
  rePrintLabel: {
    id: 'app.components.product-modal.re-print-label',
    defaultMessage: 'Re-print label',
  },
  decline: {
    id: 'app.components.product-modal.decline',
    defaultMessage: 'Decline',
  },
  unpackToDetach: {
    id: 'app.components.product-modal.unpack-to-detach',
    defaultMessage: 'Unpack to detach from order',
  },
}

export default defineMessages(messages)
